import { quebrarEmDuas } from './versus';

/** Área útil da página de Materiais: 62 px de margem de cada lado, como o texto de introdução. */
const ESQUERDA = 62;
const DIREITA = 1218;
const CENTRO = (ESQUERDA + DIREITA) / 2;
const VAO = 40;
const LARGURA_MAXIMA = 260;
/** Folga entre o rótulo e a borda da célula. */
const FOLGA = 8;

/**
 * Células de uma linha de pastas: todas com a mesma largura, centralizadas na tela e sempre
 * dentro da área útil. A largura sai da divisão da área pela quantidade, com teto, e não do
 * tamanho do rótulo: título longo numa linha de 4 estourava a borda (E2E de 27/10).
 *
 * @returns {{ largura: number, centros: number[] }}
 */
export function celulasDaLinha (quantidade) {
    const total = Math.max(1, quantidade);
    const largura = Math.min(LARGURA_MAXIMA, Math.floor((DIREITA - ESQUERDA - VAO * (total - 1)) / total));
    const passo = largura + VAO;
    const centros = Array.from({ length: total }, (_, i) => CENTRO + (i - (total - 1) / 2) * passo);
    return { largura, centros };
}

/** Rótulo da pasta: maiúsculas, em duas linhas de tamanho parecido. */
export function rotuloDaPasta (titulo) {
    return quebrarEmDuas(String(titulo ?? '').toUpperCase());
}

/** Escala que faz um rótulo largo caber na célula; rótulo que já cabe não muda. */
export function escalaDoRotulo (larguraDoRotulo, larguraDaCelula) {
    if (!(larguraDoRotulo > 0)) return 1;
    return Math.min(1, (larguraDaCelula - FOLGA) / larguraDoRotulo);
}
